import { Box, Paper, Tabs, Tab } from '@mui/material'
import { themeColors } from '../../app/layout/theme'

interface EntityTab {
  label: React.ReactNode
  content: React.ReactNode
}

interface EntityDetailTabsProps {
  tabs: EntityTab[]
  activeTab: number
  onChange: (index: number) => void
  padding?: number | string
  tabHeight?: number | string
  tabFontSize?: string
  tabFontWeight?: number | string
  tabPaddingX?: number | string
  borderRadius?: number | string
  fullHeight?: boolean
}

export const EntityDetailTabs = ({
  tabs,
  activeTab,
  onChange,
  padding = 3,
  tabHeight = 56,
  tabFontSize = '14px',
  tabFontWeight = 700,
  tabPaddingX = 3,
  borderRadius = '16px',
  fullHeight = false,
}: EntityDetailTabsProps) => {
  return (
    <Paper elevation={0} sx={{ 
      borderRadius: borderRadius, 
      border: `1px solid ${themeColors.border}`, 
      overflow: 'hidden', 
      bgcolor: '#fff',
      ...(fullHeight && { display: 'flex', flexDirection: 'column', height: '100%' })
    }}>
      {/* Tabs Header */}
      <Box sx={{ borderBottom: `1px solid ${themeColors.border}`, bgcolor: '#fff', px: 1, flexShrink: 0 }}>
        <Tabs
          value={activeTab}
          onChange={(_e, v) => onChange(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            minHeight: tabHeight,
            '& .MuiTab-root': { 
              minHeight: tabHeight, 
              textTransform: 'none', 
              fontWeight: tabFontWeight, 
              fontSize: tabFontSize, 
              px: tabPaddingX,
              color: 'text.secondary',
              transition: 'color 0.2s'
            },
            '& .MuiTabs-indicator': { 
              bgcolor: themeColors.primary, 
              height: 2, 
              borderRadius: '2px 2px 0 0' 
            },
            '& .Mui-selected': { 
              color: `${themeColors.primary} !important` 
            },
          }}
        >
          {tabs.map((tab, i) => (
            <Tab key={i} label={tab.label} id={`tab-${i}`} />
          ))}
        </Tabs>
      </Box>

      {/* Tab Content */}
      <Box sx={{ 
        p: padding,
        ...(fullHeight && { flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' })
      }}>
        {tabs[activeTab]?.content}
      </Box>
    </Paper>
  )
}
